import { defaultHttpClient } from 'shared/src/api/httpClient';
import type { GetLikedGoodsRequest, GetLikedGoodsResponse } from './types';

/**
 * - 찜한 상품 리스트
 * - iOS `LikedProductRouter.products` (`/members/me/liked_goods/`) 와 동일
 * - `last_sno` cursor 기반 pagination
 */
export const getLikedGoods = (params: GetLikedGoodsRequest) => {
  const { order, category_sno, is_fast_delivery, last_sno } = params;

  return defaultHttpClient
    .request<GetLikedGoodsResponse>({
      method: 'GET',
      url: '/api/v2/members/me/liked_goods/',
      params: {
        order,
        // -1(전체)은 서버로 보내지 않음 (iOS 동일)
        ...(category_sno !== undefined && category_sno !== -1
          ? { category_sno }
          : {}),
        is_fast_delivery,
        last_sno,
      },
    })
    .then(result => result.data);
};
